import { createReducer } from 'reduxsauce';
import { RegisterTypes } from './actions';

const requestState = {
  error: null,
  value: null,
  loading: true,
  timeTrigger: 0
};

export const INITIAL_STATE = {
  ...requestState
};

const resetRegisterTimer = (state = INITIAL_STATE) => ({
  ...state,
  timeTrigger: 0
});

const registerSuccess = (state = INITIAL_STATE, { user }) => ({
  ...state,
  value: user,
  loading: false,
  timeTrigger: new Date().getTime()
});

const registerFailure = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error,
  loading: false
});

export const HANDLERS = {
  [RegisterTypes.REGISTER_SUCCESS]: registerSuccess,
  [RegisterTypes.REGISTER_FAILURE]: registerFailure,
  [RegisterTypes.REGISTER_RESET_TIMER]: resetRegisterTimer
};

export const registerReducer = createReducer(INITIAL_STATE, HANDLERS);
